import React from 'react'
import { DefaultLayout } from '../../layouts'
import { Container, SimplePageHeader } from '../../components'
import { RelatedPosts, Sidebar, HeadComponent } from './components'
import { useLocation } from 'react-router-dom'
import { MainContent } from './components/main-content'
import { normalizer } from '../../utils'
import rawData from '../../database/blog.json'

const normalized = normalizer(rawData)

const BlogDetail = (props) => {
  const { match } = props
  const data = normalized[match.params.id]
  console.log(props)
  const location  = useLocation()
  const isNotExist = location.search.includes('exist=false')

  return (
    <DefaultLayout>
      <SimplePageHeader noPadding/>
      <Container className="pt-5 pb-10 lg:pt-20 lg:pb-20" color="#f5f5f5">
        <div className="flex flex-wrap -mx-4">
          <div className="w-full lg:w-8/12 px-4">
            <HeadComponent isNotExist={isNotExist} data={data}/>
          </div>
        </div>
        <div className="flex flex-wrap -mx-4">
          <div className="w-full lg:w-8/12 px-4 order-2 lg:order-1">
            <MainContent isNotExist={isNotExist} data={data}/>
          </div>
          <div className="w-full lg:w-3/12 lg:ml-auto px-4 order-1 lg:order-2">
            <Sidebar data={data}/>
          </div>
        </div>
      </Container>
      <RelatedPosts />
    </DefaultLayout>
  )
}

export { BlogDetail }